import { browser as browserLegacy, getBrowserInfo } from '@atlaskit/editor-common/browser';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
export var getDragBehaviour = function getDragBehaviour(_ref) {
  var altKey = _ref.altKey,
    ctrlKey = _ref.ctrlKey;
  var browser = expValEquals('platform_editor_hydratable_ui', 'isEnabled', true) ? getBrowserInfo() : browserLegacy;
  var isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
  return isCloneModifierKeyPressed ? 'clone' : 'move';
};